export const downloadByUrl = (url) => {
  let a = document.createElement('a');
  a.href = url;
  a.click();
};
